import React from 'react';
import { AiOutlineCheck } from 'react-icons/ai';

import './added-message.scss';

const AddedToCartMessage = props => {
   return props.wasAdded ? (
      <div className="pd-atc-confirm text-center">
         {props.short ?
            <span><AiOutlineCheck/></span> :
            <span><AiOutlineCheck/> &nbsp;&nbsp;&nbsp;&nbsp; Added to Cart</span>
         }
      </div>
   ) : null;
}

export default AddedToCartMessage
